export const hoverTransparentBackgroundSelector =
  '&:not([disabled]):active, &:not([disabled]):focus, &:not([disabled]):hover';

export const googleAutocompleteResultsWrapperStyles = {
  backgroundColor: 'silver.lightest',
  borderRadius: '3px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  left: '0',
  marginBottom: '12px',
  marginTop: '-24px',
  padding: '16px 0',
  position: 'absolute',
  right: '0',
  zIndex: '9',
};

export const googleAutocompletePredictionWrapperStyles = {
  cursor: 'pointer',
  margin: '0 0 4px 0',
  padding: '10px 16px',
  sx: {
    '&:last-child': { mb: '14px' },
    '&:hover, &:focus': {
      bg: 'silver.lightest',
      outline: 'none',
    },
  },
};

export const googleAutocompleteResultsSmallTextStyles = {
  color: 'grey.light',
  display: 'inline-block',
  fontSize: 'sm',
  fontWeight: 'normal',
  mb: '12px',
};

export const googleAutocompleteResultsAddressStyles = {
  ...googleAutocompleteResultsSmallTextStyles,
  fontSize: 'md',
  mb: '0',
};

export const googleAutocompleteResultsLinkStyles = {
  display: 'inline',
  fontSize: 'sm',
  fontWeight: 'semibold',
  height: 'auto',
  padding: 0,
  sx: {
    [hoverTransparentBackgroundSelector]: {
      backgroundColor: 'transparent',
    },
  },
  verticalAlign: 'revert',
};

export const googleAutocompleteNoSearchResultsTitleStyles = {
  ...googleAutocompleteResultsSmallTextStyles,
  fontSize: 'md',
  fontWeight: 'semibold',
  margin: '13px 0 10px 0',
  textAlign: 'center',
};

export const googleAutocompleteSmallTextStyles = {
  color: 'grey.light',
  display: 'inline-block',
  fontSize: 'sm',
  marginBottom: '12px',
};
